import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070f41f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-tabel-title" }, "会员拎包商加盟申请表", -1))
const _hoisted_3 = { class: "traning-tabel-line" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("万 ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("意向品牌：")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("意向品类：")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("意向城市：")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("公司名称：")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("现从事行业：")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("上年营业额：")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("意向说明：")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("接受推荐品牌：")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("联系人：")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("电话：")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("申请日期：")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("说明：")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("您的申请我们已经收到，会尽快联系你，请保持电话畅通。")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("提交申请")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("返回修改")
const _hoisted_22 = ["src"]

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from '../components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue'
import type { UploadFile, ElFile } from 'element-plus/es/components/upload/src/upload.type'
import JoinActivityVo from '@/beans/joinActivityVo';

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const radio1 = ref('1')
const active = ref(0);
const activitiesStep = [
  {
    content: '提交申请',
    timestamp: '2018-04-12 20:46',
    size: 'large',
    type: 'primary',
    icon: MoreFilled,
  },
  {
    content: '初审',
    timestamp: '2018-04-03 20:46',
    color: '#0bbd87',
  },
  {
    content: '终审',
    timestamp: '2018-04-03 20:46',
    size: 'large',
  },
];

const isDisabled = ref(false);

const ustore = useStore();
var activityJoinList = ustore.state.frontLeagueModule.activityJoinList;
var id = router.currentRoute.value.params.id;

// if (typeof id == "string") {
//   store.dispatch("frontTrainingModule/getActivityApply", { activityId: id }).then(
//     (data) => {
//       //成功
//       if (data.result != null) {
//         bindData.activityApplyForm = data.result;
//         bindData.activityApplyForm.joinCategoryIdsArray = data.result.joinCategoryIds.split(",");
//         isDisabled.value = true;
//       }
//     },
//     (error) => {
//       console.log(error.msg);
//     }
//   );
// }

store.dispatch("frontLeagueModule/listJoinCategory", {}).then(
  (data) => {
    //成功
    if (data.result != null) {
      bindData.joinCategoryList = data.result;
    }
  },
  (error) => {
    console.log(error.msg);
  }
);

store.dispatch('frontLeagueModule/listCompanyArea', {}).then(
  (data) => {
    //成功
    bindData.companyAreaList = data.result;
  },
  (error) => {
    console.log(error.msg);
  }
);

const activityApplyFormRef = ref<FormInstance>();

const bindData = reactive({
  activityJoinList: new Array<JoinActivityVo>(),
  joinCategoryList: [],
  companyAreaList: [],
  status: 1,
  activityApplyForm: {
    id: '',
    type: 7,
    activityId: '',
    contact: '',
    mobile: '',
    joinCategoryIdsArray: [],
    joinCategoryIds: '',
    activityIds: '',
    turnover: '',
    companyName: '',
    industry: '',
    explanation: '',
    intentionAreaArray: [],
    intentionArea: '',
    isAcceptRecommendBrandsBool: false,
    isAcceptRecommendBrands: 'N',
    cost: 0.00,
    isPayed:"N",
  },
  activityNames: '',
  joinCategoryNames: '',
  intentionAreaNames: '',
  applyDate: ''
});

if (activityJoinList != null) {
  bindData.activityJoinList = activityJoinList;
}

if (typeof id == "string") {
  bindData.activityApplyForm.activityId = id;
}

bindData.activityApplyForm.companyName = ustore.state.loginMember == undefined ? '' : ustore.state.loginMember.companyName

const loadData = () => {
  store.dispatch("getMyInfoAndCheckLogin").then(
    (data) => {
      //成功
      bindData.activityApplyForm.companyName = data.result.companyName;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

if (ustore.state.loginMember == undefined) {
  loadData();
}

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写联系人"));
  } else {
    callback();
  }
};

const activityApplyRules = reactive({
  contact: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  mobile: [{ required: true, message: '请填写电话', trigger: "blur" }],
});

const handleEditOk = () => {
  bindData.status = 2;
  bindData.activityNames = bindData.activityJoinList.map(activity => activity.activityName).join(',');
  const joinCategoryNames = new Array<String>();
  for (var i = 0; i < bindData.joinCategoryList.length; i++) {
    const joinCategory = bindData.joinCategoryList[i];
    if (bindData.activityApplyForm.joinCategoryIdsArray.indexOf(joinCategory.id) >= 0) {
      joinCategoryNames[joinCategoryNames.length] = joinCategory.name;
    }
  }
  bindData.joinCategoryNames = joinCategoryNames.join(',');

  const intentionAreaNames = new Array<String>();
  for (var i = 0; i < bindData.companyAreaList.length; i++) {
    const companyArea = bindData.companyAreaList[i];
    if (bindData.activityApplyForm.intentionAreaArray.indexOf(companyArea.id) >= 0) {
      intentionAreaNames[intentionAreaNames.length] = companyArea.name;
    }
  }
  bindData.intentionAreaNames = intentionAreaNames.join(',');
}

const handleBackToEdit = () => {
  bindData.status = 1;
}

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      bindData.activityApplyForm.activityIds = bindData.activityJoinList.map(activity => activity.id).join(',');
      bindData.activityApplyForm.joinCategoryIds = bindData.activityApplyForm.joinCategoryIdsArray.join(',');
      bindData.activityApplyForm.intentionArea = bindData.activityApplyForm.intentionAreaArray.join(',');
      bindData.activityApplyForm.isAcceptRecommendBrands = bindData.activityApplyForm.isAcceptRecommendBrandsBool ? 'Y' : 'N';
      handleEditOk();
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const submitData = () => {
  store.dispatch("frontLeagueModule/saveActivityApply", bindData.activityApplyForm).then(
    (data) => {
      //成功
      ElMessage.success("保存成功.");
      isDisabled.value = true;
      bindData.applyDate = data.result;
      active.value = 1;
      if (bindData.activityApplyForm.cost >= 0.01 && bindData.activityApplyForm.isPayed=="N") {
        router.push("/frontDesk/applyPayment/" + bindData.activityApplyForm.activityId);
      }
      else {
        router.push("/frontDesk/applySuccess/" + bindData.activityApplyForm.activityId);
      }
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
}

const handleEdit = () => {
  isDisabled.value = false;
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

const handleRemove = (uploadFile: UploadFile) => {
  //console.log(uploadFile, uploadFiles)
  for (var i = 0; i < bindData.activityJoinList.length; i++) {
    if (bindData.activityJoinList[i].id == uploadFile.name) {
      bindData.activityJoinList.splice(i, 1);
    }
  }
}

const handlePictureCardPreview = (uploadFile: UploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_steps, {
        active: active.value,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }, 8, ["active"]),
      (_unref(bindData).status == 1)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            class: "invest-tabel-ct",
            model: _unref(bindData).activityApplyForm,
            ref_key: "activityApplyFormRef",
            ref: activityApplyFormRef,
            "label-width": "200px",
            "status-icon": "",
            rules: _unref(activityApplyRules)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "意向品牌",
                class: "join-list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    action: "#",
                    "list-type": "picture-card",
                    "on-preview": handlePictureCardPreview,
                    "on-remove": handleRemove,
                    "file-list": _unref(bindData).activityJoinList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["file-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "意向品类",
                prop: "joinCategoryIdsArray"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _unref(bindData).activityApplyForm.joinCategoryIdsArray,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).activityApplyForm.joinCategoryIdsArray) = $event)),
                    disabled: isDisabled.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategoryList, (joinCategory) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: joinCategory.id,
                          label: joinCategory.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(joinCategory.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "意向城市",
                prop: "intentionAreaArray"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _unref(bindData).activityApplyForm.intentionAreaArray,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).activityApplyForm.intentionAreaArray) = $event)),
                    disabled: isDisabled.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).companyAreaList, (companyArea) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: companyArea.id,
                          label: companyArea.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(companyArea.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "公司名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.companyName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).activityApplyForm.companyName) = $event)),
                    prop: "companyName",
                    "input-style": "width:300px",
                    placeholder: "",
                    size: "default",
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "现从事行业" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.industry,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).activityApplyForm.industry) = $event)),
                    prop: "industry",
                    "input-style": "width:300px",
                    placeholder: "",
                    size: "default",
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "上年营业额" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(bindData).activityApplyForm.turnover,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).activityApplyForm.turnover) = $event)),
                      prop: "turnover",
                      "input-style": "width:100px;margin-right: 10px",
                      placeholder: "",
                      size: "default",
                      disabled: isDisabled.value
                    }, null, 8, ["modelValue", "disabled"]),
                    _hoisted_4
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "意向说明" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.explanation,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).activityApplyForm.explanation) = $event)),
                    prop: "explanation",
                    "input-style": "width:500px",
                    type: "textarea",
                    autocomplete: "off",
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "其他" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _unref(bindData).activityApplyForm.isAcceptRecommendBrandsBool,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).activityApplyForm.isAcceptRecommendBrandsBool) = $event)),
                    label: "接受推荐品牌",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "联系人" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.contact,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).activityApplyForm.contact) = $event)),
                    prop: "contact",
                    "input-style": "width:300px",
                    placeholder: "",
                    size: "default",
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "电话" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).activityApplyForm.mobile,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).activityApplyForm.mobile) = $event)),
                    prop: "mobile",
                    "input-style": "width:300px",
                    placeholder: "",
                    size: "default",
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : _createCommentVNode("", true),
      (_unref(bindData).status == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityNames), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).joinCategoryNames), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).intentionAreaNames), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.companyName), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.industry), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.turnover) + "万", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.explanation), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.isAcceptRecommendBrandsBool ? '是' : '否'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.contact), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "list-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "col-left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 18,
                  class: "col-right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).activityApplyForm.mobile), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(bindData).applyDate.length > 0)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  gutter: 20,
                  class: "list-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "col-left"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      class: "col-right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(bindData).applyDate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(bindData).applyDate.length > 0)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  gutter: 20,
                  class: "list-row",
                  style: {"padding-bottom":"40px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "col-left"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 18,
                      class: "col-right",
                      style: {"color":"red"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!isDisabled.value)
        ? (_openBlock(), _createBlock(_component_el_container, {
            key: 2,
            class: "invest-tabel-btn",
            style: {"padding-bottom":"40px"}
          }, {
            default: _withCtx(() => [
              (_unref(bindData).status == 1)
                ? (_openBlock(), _createBlock(_unref(ElButton), {
                    key: 0,
                    type: "primary",
                    size: "large",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm(activityApplyFormRef.value)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(bindData).status == 2)
                ? (_openBlock(), _createBlock(_unref(ElButton), {
                    key: 1,
                    type: "primary",
                    size: "large",
                    onClick: submitData
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(bindData).status == 2)
                ? (_openBlock(), _createBlock(_unref(ElButton), {
                    key: 2,
                    type: "info",
                    size: "large",
                    onClick: handleBackToEdit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          "w-full": "",
          src: dialogImageUrl.value,
          alt: "查看大图"
        }, null, 8, _hoisted_22)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Bottom)
  ]))
}
}

})